import { useEffect, useMemo, useState } from 'react'

import { logout, provideComponent } from 'scrivito'

import { DXPTopNavWidget } from './DXPTopNavWidgetClass'
import { Search } from './SubComponent'
import { ChatBotButton } from './SubComponent/ChatBotButton'
import { DXPProfileMenu } from '@/Atomic/Widgets/DXPProfileMenu'
import { ReturnLink } from '@/Components/ReturnLink'
import { SidebarToggler } from '@/Components/Sidebar/SidebarContext'
import {
  getReturnToTarget,
  isAutomationsBannerReturnToTarget,
} from '@/utils/getReturnToTarget'
import { UserInfo, getUserInfo } from '@/utils/getUserInfo'
import { getBuildTimestamp } from '@/utils/isRuntimeEnv'

import './DXPTopNavWidget.scss'

provideComponent(DXPTopNavWidget, () => {
  const returnTo = getReturnToTarget()
  const showAutomationReturnLink = isAutomationsBannerReturnToTarget(returnTo)
  const showCompactReturnLink = returnTo?.type === 'home'
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null)

  useEffect(() => {
    let cancelled = false
    getUserInfo()
      .then((result) => {
        if (!cancelled) setUserInfo(result)
      })
      .catch((err) => {
        console.warn('Failed to retrive user info!', err)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const returnHref = useMemo(() => {
    return returnTo?.url
  }, [returnTo])

  const tms = getBuildTimestamp()
  const userTitle = userInfo?.name
    ? `${userInfo.name}\nVersion: ${tms}`
    : `Version: ${tms}`

  return (
    <>
      {showAutomationReturnLink && returnHref ? (
        <ReturnLink href={returnHref} targetType="automations" />
      ) : null}
      <div className="dxp-topbar">
        <SidebarToggler />
        {showCompactReturnLink && returnHref ? (
          <div className="dxp-topbar-return">
            <ReturnLink href={returnHref} targetType="home" />
          </div>
        ) : (
          <div title={userTitle} className="dxp-topbar-logo" />
        )}
        <Search />
        <DXPProfileMenu
          user={{
            email: userInfo?.email,
            name: userInfo?.name,
            picture: userInfo?.picture,
            given_name: userInfo?.given_name,
            family_name: userInfo?.family_name,
          }}
          onLogout={logout}
        />
        <ChatBotButton />
      </div>
    </>
  )
})
